/*
 * Free gift with purchase
 * Settings: Theme settings → 满额赠品 Free gift (snippets/free-gift.liquid)
 * Cart state: sections/free-gift-data.liquid (Section Rendering API)
 *
 * - Cart reaches the threshold → gift is added (single gift with a single available variant)
 *   or a popup asks the customer to pick a gift / colour.
 * - Cart drops below the threshold → gift is removed.
 * - Checkout click below the threshold → popup with the remaining amount.
 * The 0 € price itself comes from the store's Buy X Get Y automatic discount.
 */
(function () {
  'use strict';

  var configEl = document.getElementById('FreeGiftConfig');
  if (!configEl || window.FreeGift) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    return;
  }

  var I18N = {
    en: {
      choose_title: 'Choose your free gift',
      choose_text: 'Your order qualifies for a free gift. Pick the one you like:',
      choose_variant: 'Choose your option:',
      add: 'Add free gift',
      no_thanks: 'No thanks',
      checkout_without: 'Continue to checkout without gift',
      reminder_title: 'Orders of [threshold] or more get one of these gifts for free',
      reminder_title_single: 'Orders of [threshold] or more get this gift for free',
      reminder_text: "You're only [amount] away from your free gift.",
      reminder_text_restricted: "You're only [amount] of eligible products away from your free gift.",
      continue_shopping: 'Continue shopping',
      checkout_anyway: 'Continue to checkout',
      sold_out: 'Sold out',
      close: 'Close',
      error: 'The gift could not be added. Please try again.',
    },
    it: {
      choose_title: 'Scegli il tuo regalo',
      choose_text: 'Il tuo ordine ha superato 80 €: scegli modello e colore.',
      choose_variant: "Scegli l'opzione:",
      add: 'Aggiungi il regalo',
      no_thanks: 'No, grazie',
      checkout_without: 'Procedi al checkout senza regalo',
      reminder_title: 'Con un ordine da [threshold] in su ricevi in regalo uno di questi articoli',
      reminder_title_single: 'Con un ordine da [threshold] in su ricevi in regalo questo articolo',
      reminder_text: 'Ti mancano solo [amount] per ricevere il tuo regalo.',
      reminder_text_restricted: 'Ti mancano solo [amount] di prodotti idonei per ricevere il tuo regalo.',
      continue_shopping: 'Continua lo shopping',
      checkout_anyway: 'Procedi al checkout',
      sold_out: 'Esaurito',
      close: 'Chiudi',
      error: 'Impossibile aggiungere il regalo. Riprova.',
    },
    de: {
      choose_title: 'Wähle dein Gratisgeschenk',
      choose_text: 'Deine Bestellung erhält ein Gratisgeschenk. Wähle dein Wunschgeschenk:',
      choose_variant: 'Option wählen:',
      add: 'Geschenk hinzufügen',
      no_thanks: 'Nein, danke',
      checkout_without: 'Ohne Geschenk zur Kasse',
      reminder_title: 'Ab [threshold] Bestellwert erhältst du eines dieser Geschenke gratis',
      reminder_title_single: 'Ab [threshold] Bestellwert erhältst du dieses Geschenk gratis',
      reminder_text: 'Dir fehlen nur noch [amount] bis zu deinem Gratisgeschenk.',
      reminder_text_restricted: 'Dir fehlen nur noch [amount] an teilnehmenden Produkten bis zu deinem Gratisgeschenk.',
      continue_shopping: 'Weiter einkaufen',
      checkout_anyway: 'Weiter zur Kasse',
      sold_out: 'Ausverkauft',
      close: 'Schließen',
      error: 'Das Geschenk konnte nicht hinzugefügt werden. Bitte versuche es erneut.',
    },
    fr: {
      choose_title: 'Choisissez votre cadeau',
      choose_text: 'Votre commande vous donne droit à un cadeau offert. Choisissez celui que vous préférez :',
      choose_variant: 'Choisissez une option :',
      add: 'Ajouter le cadeau',
      no_thanks: 'Non merci',
      checkout_without: 'Passer commande sans cadeau',
      reminder_title: "Dès [threshold] d'achat, recevez l'un de ces cadeaux offert",
      reminder_title_single: "Dès [threshold] d'achat, recevez ce cadeau offert",
      reminder_text: 'Plus que [amount] pour recevoir votre cadeau.',
      reminder_text_restricted: 'Plus que [amount] de produits éligibles pour recevoir votre cadeau.',
      continue_shopping: 'Continuer mes achats',
      checkout_anyway: 'Passer commande',
      sold_out: 'Épuisé',
      close: 'Fermer',
      error: "Impossible d'ajouter le cadeau. Veuillez réessayer.",
    },
    es: {
      choose_title: 'Elige tu regalo',
      choose_text: 'Tu pedido incluye un regalo gratis. Elige el que prefieras:',
      choose_variant: 'Elige una opción:',
      add: 'Añadir regalo',
      no_thanks: 'No, gracias',
      checkout_without: 'Finalizar compra sin regalo',
      reminder_title: 'Con pedidos desde [threshold], llévate gratis uno de estos regalos',
      reminder_title_single: 'Con pedidos desde [threshold], llévate gratis este regalo',
      reminder_text: 'Solo te faltan [amount] para conseguir tu regalo.',
      reminder_text_restricted: 'Solo te faltan [amount] en productos participantes para conseguir tu regalo.',
      continue_shopping: 'Seguir comprando',
      checkout_anyway: 'Finalizar compra',
      sold_out: 'Agotado',
      close: 'Cerrar',
      error: 'No se pudo añadir el regalo. Inténtalo de nuevo.',
    },
    nl: {
      choose_title: 'Kies je gratis cadeau',
      choose_text: 'Je bestelling komt in aanmerking voor een gratis cadeau. Kies het cadeau dat je wilt:',
      choose_variant: 'Kies een optie:',
      add: 'Cadeau toevoegen',
      no_thanks: 'Nee, bedankt',
      checkout_without: 'Afrekenen zonder cadeau',
      reminder_title: 'Bij bestellingen vanaf [threshold] krijg je een van deze cadeaus gratis',
      reminder_title_single: 'Bij bestellingen vanaf [threshold] krijg je dit cadeau gratis',
      reminder_text: 'Nog maar [amount] tot je gratis cadeau.',
      reminder_text_restricted: 'Nog maar [amount] aan deelnemende producten tot je gratis cadeau.',
      continue_shopping: 'Verder winkelen',
      checkout_anyway: 'Afrekenen',
      sold_out: 'Uitverkocht',
      close: 'Sluiten',
      error: 'Het cadeau kon niet worden toegevoegd. Probeer het opnieuw.',
    },
    pl: {
      choose_title: 'Wybierz darmowy prezent',
      choose_text: 'Twoje zamówienie kwalifikuje się do darmowego prezentu. Wybierz ten, który Ci się podoba:',
      choose_variant: 'Wybierz opcję:',
      add: 'Dodaj prezent',
      no_thanks: 'Nie, dziękuję',
      checkout_without: 'Przejdź do kasy bez prezentu',
      reminder_title: 'Przy zamówieniu od [threshold] otrzymasz gratis jeden z tych prezentów',
      reminder_title_single: 'Przy zamówieniu od [threshold] otrzymasz ten prezent gratis',
      reminder_text: 'Brakuje Ci tylko [amount] do darmowego prezentu.',
      reminder_text_restricted: 'Brakuje Ci tylko [amount] w produktach objętych promocją do darmowego prezentu.',
      continue_shopping: 'Kontynuuj zakupy',
      checkout_anyway: 'Przejdź do kasy',
      sold_out: 'Wyprzedane',
      close: 'Zamknij',
      error: 'Nie udało się dodać prezentu. Spróbuj ponownie.',
    },
    pt: {
      choose_title: 'Escolha o seu presente',
      choose_text: 'A sua encomenda tem direito a um presente grátis. Escolha o que preferir:',
      choose_variant: 'Escolha uma opção:',
      add: 'Adicionar presente',
      no_thanks: 'Não, obrigado',
      checkout_without: 'Finalizar compra sem presente',
      reminder_title: 'Em encomendas a partir de [threshold], receba grátis um destes presentes',
      reminder_title_single: 'Em encomendas a partir de [threshold], receba grátis este presente',
      reminder_text: 'Faltam apenas [amount] para receber o seu presente.',
      reminder_text_restricted: 'Faltam apenas [amount] em produtos elegíveis para receber o seu presente.',
      continue_shopping: 'Continuar a comprar',
      checkout_anyway: 'Finalizar compra',
      sold_out: 'Esgotado',
      close: 'Fechar',
      error: 'Não foi possível adicionar o presente. Tente novamente.',
    },
  };

  var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var t = Object.assign({}, I18N.en, I18N[lang] || {});
  if (config.texts && config.texts.choose_title) t.choose_title = config.texts.choose_title;
  if (config.texts && config.texts.reminder_title) {
    t.reminder_title = config.texts.reminder_title;
    t.reminder_title_single = config.texts.reminder_title;
  }
  if (config.texts && config.texts.reminder_text) {
    t.reminder_text = config.texts.reminder_text;
    t.reminder_text_restricted = config.texts.reminder_text;
  }

  var products = (config.products || []).filter(function (product) {
    return product.variants.some(function (variant) {
      return variant.available;
    });
  });
  // Every gift sold out: nothing to add and nothing to promise
  if (!products.length) return;

  var themeRoutes = (window.theme && window.theme.routes) || {};
  var root = themeRoutes.root || '/';
  var routes = {
    cart: themeRoutes.cart_url || root + 'cart',
    add: (themeRoutes.cart_add_url || root + 'cart/add') + '.js',
    update: (themeRoutes.cart_update_url || root + 'cart/update') + '.js',
    checkout: root + 'checkout',
  };

  var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
  var threshold = Math.round(Number(config.threshold || 0) * 100 * rate);
  var byQuantity = config.condition === 'quantity';
  var minQuantity = Math.max(1, Math.floor(Number(config.min_quantity) || 1));

  var KEY_ADDED = 'freeGift:added';
  var KEY_DECLINED = 'freeGift:declined';
  var store = {
    get: function (key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    },
    set: function (key, value) {
      try {
        window.sessionStorage.setItem(key, value);
      } catch (error) {}
    },
    remove: function (key) {
      try {
        window.sessionStorage.removeItem(key);
      } catch (error) {}
    },
  };

  var REQUEST_HEADER = 'X-Free-Gift';
  var CHECKOUT_SELECTOR = 'button[name="checkout"], input[name="checkout"], a[href$="/checkout"]';

  var lastState = null;
  var modal = null;
  var running = false;
  var queued = false;
  var timer = null;
  var bypassElement = null;

  /* ---------- Helpers ---------- */

  function formatMoney(cents) {
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      // The money format can contain HTML (e.g. <span class="langwill-money">), we only need the text
      var holder = document.createElement('div');
      holder.innerHTML = window.theme.formatMoney(cents, window.theme.moneyFormat);
      return holder.textContent.trim();
    }
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {style: 'currency', currency: currency}).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function post(url, body) {
    var headers = {'Content-Type': 'application/json', Accept: 'application/json'};
    headers[REQUEST_HEADER] = '1';

    return fetch(url, {method: 'POST', credentials: 'same-origin', headers: headers, body: JSON.stringify(body)}).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  function fetchState() {
    var headers = {};
    headers[REQUEST_HEADER] = '1';

    return fetch(routes.cart + '?section_id=free-gift-data', {credentials: 'same-origin', cache: 'no-store', headers: headers})
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-free-gift-state]');
        if (!el) throw new Error('free-gift-data section not found');
        return JSON.parse(el.textContent);
      });
  }

  // A participating product must be in the cart; the threshold then counts the whole cart (gift excluded)
  function qualifies(state) {
    if (state.eligible_count < 1) return false;
    if (byQuantity) return state.cart_count >= minQuantity;
    return state.cart_total >= threshold;
  }

  function autoVariantId() {
    if (products.length !== 1) return null;
    var available = products[0].variants.filter(function (variant) {
      return variant.available;
    });
    return available.length === 1 ? available[0].id : null;
  }

  function addGift(variantId) {
    return post(routes.add, {items: [{id: variantId, quantity: 1, properties: {_free_gift: '1'}}]}).then(function () {
      store.set(KEY_ADDED, '1');
      store.remove(KEY_DECLINED);
    });
  }

  function refreshCart() {
    var onCartPage = /\/cart\/?$/.test(window.location.pathname);
    if (window.theme && window.theme.settings && window.theme.settings.cartType === 'page' && onCartPage) {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
  }

  function giftNames() {
    return products
      .map(function (product) {
        return product.title;
      })
      .join(' / ');
  }

  /* ---------- Cart evaluation ---------- */

  function evaluate() {
    return fetchState().then(function (state) {
      lastState = state;
      var lines = state.gift_lines;

      if (!qualifies(state)) {
        store.remove(KEY_ADDED);
        store.remove(KEY_DECLINED);
        if (modal && modal.type === 'choose') closeModal();
        if (!lines.length) return false;

        var removeAll = {};
        lines.forEach(function (line) {
          removeAll[line.key] = 0;
        });
        return post(routes.update, {updates: removeAll}).then(function () {
          return true;
        });
      }

      if (lines.length) {
        store.set(KEY_ADDED, '1');
        if (modal && modal.type === 'choose' && !modal.checkoutTarget) closeModal();

        // Only one gift, quantity 1
        var updates = {};
        var needsUpdate = false;
        lines.forEach(function (line, index) {
          var quantity = index === 0 ? 1 : 0;
          if (line.quantity !== quantity) {
            updates[line.key] = quantity;
            needsUpdate = true;
          }
        });
        if (!needsUpdate) return false;
        return post(routes.update, {updates: updates}).then(function () {
          return true;
        });
      }

      if (store.get(KEY_ADDED)) {
        // The customer removed the gift: respect it, ask again at checkout
        store.remove(KEY_ADDED);
        store.set(KEY_DECLINED, '1');
        return false;
      }

      if (store.get(KEY_DECLINED) || modal) return false;

      var variantId = autoVariantId();
      if (variantId) {
        return addGift(variantId)
          .then(function () {
            return true;
          })
          .catch(function (error) {
            store.set(KEY_DECLINED, '1');
            console.warn('[free-gift]', error);
            return false;
          });
      }

      openChooser(null);
      return false;
    }).then(function (changed) {
      if (!changed) return;
      return fetchState().then(function (state) {
        lastState = state;
        refreshCart();
      });
    });
  }

  function run() {
    if (running) {
      queued = true;
      return;
    }
    running = true;
    evaluate()
      .catch(function (error) {
        console.warn('[free-gift]', error);
      })
      .then(function () {
        running = false;
        if (queued) {
          queued = false;
          run();
        }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 150);
  }

  /* ---------- Modal ---------- */

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (key) {
      if (key === 'text') node.textContent = attrs[key];
      else if (key === 'onclick') node.addEventListener('click', attrs[key]);
      else node.setAttribute(key, attrs[key]);
    });
    (children || []).forEach(function (child) {
      if (child) node.appendChild(child);
    });
    return node;
  }

  function openModal(type, build, checkoutTarget) {
    closeModal();

    var dialog = el('div', {class: 'free-gift-modal__dialog', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'FreeGiftModalTitle'});
    var container = el('div', {class: 'free-gift-modal'}, [el('div', {class: 'free-gift-modal__overlay'}), dialog]);

    modal = {
      type: type,
      container: container,
      dialog: dialog,
      checkoutTarget: checkoutTarget || null,
      onDismiss: null,
      previousOverflow: document.documentElement.style.overflow,
      previousFocus: document.activeElement,
    };

    build(dialog);

    container.querySelector('.free-gift-modal__overlay').addEventListener('click', dismissModal);
    dialog.insertBefore(el('button', {type: 'button', class: 'free-gift-modal__close', 'aria-label': t.close, text: '×', onclick: dismissModal}), dialog.firstChild);

    document.body.appendChild(container);
    document.documentElement.style.overflow = 'hidden';
    var focusTarget = dialog.querySelector('button:not(.free-gift-modal__close):not([disabled])') || dialog.querySelector('button');
    if (focusTarget) focusTarget.focus();
  }

  function closeModal() {
    if (!modal) return;
    var current = modal;
    modal = null;
    current.container.remove();
    document.documentElement.style.overflow = current.previousOverflow;
    if (current.previousFocus && typeof current.previousFocus.focus === 'function' && document.contains(current.previousFocus)) {
      current.previousFocus.focus();
    }
  }

  function dismissModal() {
    if (!modal) return;
    var onDismiss = modal.onDismiss;
    closeModal();
    if (onDismiss) onDismiss();
  }

  function proceedToCheckout(target) {
    if (target && document.contains(target)) {
      bypassElement = target;
      target.click();
      setTimeout(function () {
        bypassElement = null;
      }, 0);
    } else {
      window.location.href = routes.checkout;
    }
  }

  function productCard(product, imageSrc, attrs) {
    var image = imageSrc ? el('span', {class: 'free-gift-modal__image'}, [el('img', {src: imageSrc, alt: product.title, loading: 'lazy'})]) : null;
    return el(attrs.static ? 'div' : 'button', Object.assign({class: 'free-gift-modal__product' + (attrs.static ? ' free-gift-modal__product--static' : '')}, attrs.static ? {} : {type: 'button'}, attrs.html || {}), [
      image,
      el('span', {text: product.title}),
    ]);
  }

  function openChooser(checkoutTarget) {
    var selectedProduct = products.length === 1 ? products[0] : null;
    var selectedVariant = null;

    function availableVariants(product) {
      return product.variants.filter(function (variant) {
        return variant.available;
      });
    }

    function selectProduct(product) {
      selectedProduct = product;
      var available = availableVariants(product);
      selectedVariant = available.length === 1 ? available[0] : null;
    }

    if (selectedProduct) selectProduct(selectedProduct);

    openModal(
      'choose',
      function (dialog) {
        var body = el('div');
        dialog.appendChild(body);

        function render() {
          body.innerHTML = '';
          body.appendChild(el('h2', {class: 'free-gift-modal__title', id: 'FreeGiftModalTitle', text: t.choose_title}));
          body.appendChild(el('p', {class: 'free-gift-modal__text', text: t.choose_text}));

          var grid = el('div', {class: 'free-gift-modal__products'});
          products.forEach(function (product) {
            var image = product.image;
            if (product === selectedProduct && selectedVariant && selectedVariant.image) image = selectedVariant.image;

            if (products.length === 1) {
              grid.appendChild(productCard(product, image, {static: true}));
              return;
            }
            var card = productCard(product, image, {html: {'aria-pressed': String(product === selectedProduct)}});
            card.addEventListener('click', function () {
              selectProduct(product);
              render();
            });
            grid.appendChild(card);
          });
          body.appendChild(grid);

          if (selectedProduct && selectedProduct.variants.length > 1) {
            body.appendChild(el('p', {class: 'free-gift-modal__label', text: t.choose_variant}));
            var variants = el('div', {class: 'free-gift-modal__variants'});
            selectedProduct.variants.forEach(function (variant) {
              var attrs = {
                type: 'button',
                class: 'free-gift-modal__variant',
                'aria-pressed': String(variant === selectedVariant),
                text: variant.title,
              };
              if (!variant.available) {
                attrs.disabled = 'disabled';
                attrs.title = t.sold_out;
              }
              var button = el('button', attrs);
              button.addEventListener('click', function () {
                selectedVariant = variant;
                render();
              });
              variants.appendChild(button);
            });
            body.appendChild(variants);
          }

          var error = el('p', {class: 'free-gift-modal__text', role: 'alert'});
          var addAttrs = {type: 'button', class: 'btn btn--full btn--primary btn--solid', text: t.add};
          if (!selectedVariant) addAttrs.disabled = 'disabled';
          var addButton = el('button', addAttrs);
          addButton.addEventListener('click', function () {
            if (!selectedVariant) return;
            addButton.disabled = true;
            error.textContent = '';
            addGift(selectedVariant.id)
              .then(function () {
                var target = modal && modal.checkoutTarget;
                closeModal();
                return fetchState().then(function (state) {
                  lastState = state;
                  if (target !== null && target !== undefined) {
                    proceedToCheckout(target);
                  } else {
                    refreshCart();
                  }
                });
              })
              .catch(function (err) {
                console.warn('[free-gift]', err);
                error.textContent = t.error;
                addButton.disabled = false;
              });
          });

          var declineButton = el('button', {type: 'button', class: 'free-gift-modal__link', text: checkoutTarget ? t.checkout_without : t.no_thanks, onclick: dismissModal});

          body.appendChild(error);
          body.appendChild(el('div', {class: 'free-gift-modal__actions'}, [addButton, declineButton]));
        }

        render();
      },
      checkoutTarget
    );

    modal.onDismiss = function () {
      store.set(KEY_DECLINED, '1');
      if (checkoutTarget) proceedToCheckout(checkoutTarget);
    };
  }

  function openReminder(checkoutTarget, state) {
    var remaining = Math.max(threshold - state.cart_total, 0);
    function fill(template) {
      return template.split('[amount]').join(formatMoney(remaining)).split('[threshold]').join(formatMoney(threshold)).split('[gift]').join(giftNames());
    }
    var title = fill(products.length === 1 ? t.reminder_title_single : t.reminder_title);
    // The remaining amount can be made up with any product, so no "eligible products" wording
    var text = fill(t.reminder_text);
    var shown = products;

    openModal(
      'reminder',
      function (dialog) {
        var grid = el('div', {class: 'free-gift-modal__products'});
        shown.forEach(function (product) {
          grid.appendChild(productCard(product, product.image, {static: true}));
        });

        dialog.appendChild(el('h2', {class: 'free-gift-modal__title', id: 'FreeGiftModalTitle', text: title}));
        dialog.appendChild(el('p', {class: 'free-gift-modal__text', text: text}));
        if (shown.length) dialog.appendChild(grid);
        dialog.appendChild(
          el('div', {class: 'free-gift-modal__actions'}, [
            el('button', {type: 'button', class: 'btn btn--full btn--primary btn--solid', text: t.continue_shopping, onclick: closeModal}),
            el('button', {
              type: 'button',
              class: 'btn btn--full btn--primary btn--outline',
              text: t.checkout_anyway,
              onclick: function () {
                closeModal();
                proceedToCheckout(checkoutTarget);
              },
            }),
          ])
        );
      },
      checkoutTarget
    );
  }

  /* ---------- Events ---------- */

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target && event.target.closest ? event.target.closest(CHECKOUT_SELECTOR) : null;
      if (!target) return;
      if (target === bypassElement) {
        bypassElement = null;
        return;
      }
      if (!lastState || modal) return;

      if (!qualifies(lastState)) {
        // Amount reminder only in amount mode, and only when the cart holds participating products
        if (!config.reminder || byQuantity || lastState.eligible_count === 0) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        openReminder(target, lastState);
        return;
      }

      if (!lastState.gift_lines.length) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openChooser(target);
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (modal && event.key === 'Escape') dismissModal();
  });

  document.addEventListener('theme:cart:change', schedule);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) schedule();
  });

  // Cart changes made by apps that don't fire theme events
  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function (resource, options) {
      var promise = originalFetch.apply(this, arguments);
      try {
        var url = typeof resource === 'string' ? resource : resource && resource.url;
        var headers = (options && options.headers) || {};
        var own = headers instanceof Headers ? headers.has(REQUEST_HEADER) : Boolean(headers[REQUEST_HEADER]);
        if (!own && url && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
          promise.then(schedule, function () {});
        }
      } catch (error) {}
      return promise;
    };
  }

  // Debug in the browser console: FreeGift.state()
  window.FreeGift = {
    refresh: schedule,
    state: function () {
      return {condition: byQuantity ? 'quantity' : 'amount', threshold: threshold, minQuantity: minQuantity, restricted: config.restricted, cart: lastState};
    },
  };
  run();
})();
